import { IOfferState } from '../../redux/reducers';

/**
 *
 * @description Проверяет, выбрана ли категория "Аренда офиса в бизнес-центре".
 */
export function checkBusinessCenterCategory(offer: IOfferState): boolean {
  const { category, coworkingOfferType } = offer;

  return category === 'officeRent' && !!coworkingOfferType;
}
